module.exports = __webpack_public_path__ + "static/media/scan.b12980fd.png";